import { ReactNode } from "react";
import "./HeadlineStatCard.scss";

type HeadlineStatCardProps = {
  label: string;
  labelInfo?: ReactNode;
  value: ReactNode;
  subtitle: ReactNode;
  footer?: ReactNode;
  className?: string;
};

const HeadlineStatCard = ({
  label,
  labelInfo,
  value,
  subtitle,
  footer,
  className,
}: HeadlineStatCardProps) => (
  <div className={["headline-stat-card", className].filter(Boolean).join(" ")}>
    <div className="headline-stat-card__label-row">
      <div className="headline-stat-card__label">{label}</div>
      {labelInfo}
    </div>
    <div className="headline-stat-card__value">{value}</div>
    <div className="headline-stat-card__sub">{subtitle}</div>
    {footer}
  </div>
);

type HeadlineStatCardFooterProps = {
  children: ReactNode;
  block?: boolean;
};

export const HeadlineStatCardFooter = ({
  children,
  block = false,
}: HeadlineStatCardFooterProps) => (
  <div
    className={
      block ? "headline-stat-card__footer-block" : "headline-stat-card__footer"
    }
  >
    {children}
  </div>
);

type HeadlineStatCardFooterRowProps = {
  children: ReactNode;
  icon?: ReactNode;
  iconClassName?: string;
};

export const HeadlineStatCardFooterRow = ({
  children,
  icon,
  iconClassName,
}: HeadlineStatCardFooterRowProps) => (
  <div className="headline-stat-card__footer-row">
    {icon ? (
      <span className={iconClassName} aria-hidden="true">
        {icon}
      </span>
    ) : null}
    {children}
  </div>
);

export default HeadlineStatCard;
